/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTableCardStore } from '@/features/table-cards/store/useTableCardStore'
import { useImageSlots } from '@/shared/store/useImageSlots'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import TableCardForm from '@/features/table-cards/form/TableCardForm/TableCardForm'
import Modal from '../Modal'
import {
  qrCodeCardsPostPayloadModel,
  qrCodeCardsPutPayloadModel
} from '@/features/table-cards/api/TableCardsManagementAPI.model'
import { useFormDirtyStore } from '@/shared/store/useFormDirtyStore'
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal'

interface TableCardModalProps {
  submitFunction: (
    payload: qrCodeCardsPostPayloadModel | qrCodeCardsPutPayloadModel
  ) => void
  noEdit?: boolean
  setNoEdit: Dispatch<SetStateAction<boolean>>
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
}

function TableCardModal(props: TableCardModalProps) {
  const { submitFunction, noEdit = false, setNoEdit, isOpen, setIsOpen } = props

  const setIsDirty = useFormDirtyStore(s => s.setIsDirty)
  const resetIsDirty = useFormDirtyStore(s => s.reset)

  const isFormDirty = useTableCardStore.getState().checkIsDirty()
  const { clearAll } = useImageSlots(s => s)

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    if (isOpen) {
      setIsDirty(isFormDirty)
    }
  }, [isFormDirty, isOpen])

  const handleOnConfirmClose = () => {
    resetIsDirty()
    setIsOpen(false)
    clearAll()
    setNoEdit(false)
    setIsConfirmationModalOpen(false)
    useTableCardStore.getState().resetToInitialState()
  }

  const handleOnClose = () => {
    if (isFormDirty) {
      setIsConfirmationModalOpen(true)
    } else {
      handleOnConfirmClose()
    }
  }

  return (
    <>
      <Modal
        title={t('TABLE_CARD_MODAL.TITLE')}
        size="large"
        onClose={handleOnClose}
        isOpen={isOpen}
      >
        <TableCardForm noEdit={noEdit} submitFunction={submitFunction} />
      </Modal>
      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        onConfirm={handleOnConfirmClose}
        onClose={() => setIsConfirmationModalOpen(false)}
        title={t('CONFIRMATION_MODAL.TITLE')}
        message={t('CONFIRMATION_MODAL.DESCRIPTION')}
      />
    </>
  )
}
export default TableCardModal
